(() => {
  'use strict';
  if (window.__rnfOriginalPhotoBadge) {
    window.__rnfOriginalPhotoBadge.mount(document);
    return;
  }

  // Only the merchant's two requested models and their exact original photographs.
  const enabledModels = new Set(['vz5', 'n30']);
  const cdn = 'https://cdn.shopify.com/s/files/1/0919/3340/9621/files/';
  const photographs = {
    'RNF-frontal-bronce-original-1200.jpg': {
      model: 'vz5', version: '1792507430',
      badge: '149_1d9430b8-bac3-4fb3-a2b9-486229772397.gif?v=1792161746',
      wheel: [60, 46.5, 147, 3],
      wheelDisplay: [48, 26, 170]
    },
    'RNF-frontal-azul-original-1200.jpg': {
      model: 'n30', version: '1792507397',
      badge: '150_585ef729-be74-4831-8edf-4ea23d115a5a.gif?v=1792161844',
      wheel: [48, 26, 170, 4.15]
    },
    'RNF-frontal-rojo-original-1200.jpg': {
      model: 'n30', version: '1792507424',
      badge: '151_90d883f0-20ef-4782-8c33-d675f613c7b6.gif?v=1792161844',
      wheel: [48, 26, 170, 4.15]
    }
  };
  const records = new Map();
  const containers = new Map();
  const sources = new Map();
  const suppressed = new Map();
  const queued = new Set();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let destroyed = false;
  const style = document.createElement('style');
  style.dataset.rnfOriginalPhotoStyle = '';
  style.textContent = `
    .rnf-original-photo-badge{position:absolute;overflow:hidden;pointer-events:none;z-index:2;contain:strict}
    .rnf-original-photo-badge[hidden]{display:none!important}
    .rnf-original-photo-badge__plane{position:absolute;width:1200px;height:1200px;transform-origin:0 0}
    .rnf-original-photo-badge__plate{position:absolute;left:0;top:0;width:260px;height:260px;background-repeat:no-repeat;background-size:1200px 1200px}
    .rnf-original-photo-badge__wheel{position:absolute;overflow:hidden;border-radius:50%;background:#fff}
    .rnf-original-photo-badge__face{display:block;width:100%;height:100%;background-repeat:no-repeat;background-size:1200px 1200px;transform-origin:50% 50%;animation:rnf-original-photo-spin var(--rnf-original-turn) linear infinite;animation-play-state:paused}
    .rnf-original-photo-badge.is-running .rnf-original-photo-badge__face{animation-play-state:running;will-change:transform}
    .rnf-original-photo-suppressed{visibility:hidden!important}
    @keyframes rnf-original-photo-spin{to{transform:rotate(360deg)}}
    @media(prefers-reduced-motion:reduce){.rnf-original-photo-badge__face{animation:none!important}}
  `;
  document.head.append(style);

  function identify(source) {
    if (!source) return null;
    try {
      const url = new URL(source, location.href);
      const photograph = photographs[url.pathname.split('/').pop()];
      return photograph && enabledModels.has(photograph.model) &&
        url.searchParams.get('v') === photograph.version ? photograph : null;
    } catch (_) { return null; }
  }

  function displayedPhotograph(img) {
    const declared = img.getAttribute('src');
    const current = img.currentSrc;
    // A variant can change src before currentSrc has finished updating.
    if (declared && !identify(declared) && !img.closest('picture')) return null;
    if (current && declared && identify(current) !== identify(declared) && !img.closest('picture')) return null;
    return identify(current || declared);
  }

  function positionOffset(token, free) {
    if (token === 'left' || token === 'top') return 0;
    if (token === 'right' || token === 'bottom') return free;
    if (!token || token === 'center') return free / 2;
    if (token.endsWith('%')) return free * parseFloat(token) / 100;
    if (token.startsWith('calc(')) {
      const match = token.match(/^calc\(\s*([-\d.]+)%\s*([+-])\s*([\d.]+)px\s*\)$/);
      if (match) return free * Number(match[1]) / 100 + (match[2] === '+' ? 1 : -1) * Number(match[3]);
    }
    return parseFloat(token) || 0;
  }

  function offsets(position, freeX, freeY) {
    const tokens = (position || '50% 50%').match(/calc\([^)]*\)|[^\s]+/g) || [];
    if (tokens.length === 4) {
      const edge = (keyword, amount, free) => keyword === 'right' || keyword === 'bottom'
        ? free - positionOffset(amount, free) : positionOffset(amount, free);
      if (tokens[0] === 'top' || tokens[0] === 'bottom') {
        return [edge(tokens[2], tokens[3], freeX), edge(tokens[0], tokens[1], freeY)];
      }
      return [edge(tokens[0], tokens[1], freeX), edge(tokens[2], tokens[3], freeY)];
    }
    if (tokens.length === 1 && /^(top|bottom)$/.test(tokens[0])) tokens.unshift('50%');
    if (/^(top|bottom)$/.test(tokens[0])) tokens.reverse();
    return [positionOffset(tokens[0], freeX), positionOffset(tokens[1], freeY)];
  }

  function releaseSuppressed(record) {
    record.suppressed.forEach(node => {
      const owners = suppressed.get(node);
      owners?.delete(record);
      if (!owners?.size) {
        node.classList.remove('rnf-original-photo-suppressed');
        suppressed.delete(node);
      }
    });
    record.suppressed.clear();
  }

  function sync(record) {
    const computed = getComputedStyle(record.img);
    const show = record.ready && record.img.complete && record.img.naturalWidth > 0 &&
      record.img.isConnected && !record.previewing && computed.display !== 'none' &&
      computed.visibility !== 'hidden' && Number(computed.opacity || 1) !== 0 && record.hasSize;
    record.layer.hidden = !show;
    record.layer.classList.toggle('is-running', show && record.visible && !document.hidden && !reduced.matches);
    releaseSuppressed(record);
    if (!show) return;
    // Only suppress sibling legacy decorations for this photograph, never another card.
    const media = record.img.parentElement;
    Array.from(media?.children || []).forEach(node => {
      if (!node.matches('.rnf-card-rim,.rnf-wheel-layer,.rnf-spin-wheel-badge')) return;
      let owners = suppressed.get(node);
      if (!owners) { owners = new Set(); suppressed.set(node, owners); }
      owners.add(record);
      record.suppressed.add(node);
      node.classList.add('rnf-original-photo-suppressed');
    });
  }

  function loadBadge(record) {
    if (!record.visible || record.loading) return;
    record.loading = true;
    const url = cdn + record.photograph.badge + '&format=png&width=1200';
    let source = sources.get(url);
    if (!source) {
      source = new Promise(resolve => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => resolve(image.naturalWidth === 1200 && image.naturalHeight === 1200);
        image.onerror = () => resolve(false);
        image.src = url;
      });
      sources.set(url, source);
    }
    source.then(success => {
      if (destroyed || records.get(record.img) !== record || !success) return;
      record.plate.style.backgroundImage = `url(${JSON.stringify(url)})`;
      record.face.style.backgroundImage = `url(${JSON.stringify(url)})`;
      record.ready = true;
      sync(record);
    });
  }

  function layout(record) {
    const { img, layer, plane } = record;
    const computed = getComputedStyle(img);
    const paddingX = (parseFloat(computed.paddingLeft) || 0) + (parseFloat(computed.paddingRight) || 0);
    const paddingY = (parseFloat(computed.paddingTop) || 0) + (parseFloat(computed.paddingBottom) || 0);
    const width = Math.max(0, img.clientWidth - paddingX);
    const height = Math.max(0, img.clientHeight - paddingY);
    record.hasSize = !!(width && height);
    if (!record.hasSize) { sync(record); return; }
    const fit = computed.objectFit;
    let scaleX = width / 1200;
    let scaleY = height / 1200;
    if (fit !== 'fill') {
      let scale = fit === 'cover' ? Math.max(scaleX, scaleY) : Math.min(scaleX, scaleY);
      if (fit === 'none') scale = 1;
      if (fit === 'scale-down') scale = Math.min(1, scale);
      scaleX = scaleY = scale;
    }
    const [left, top] = offsets(computed.objectPosition, width - 1200 * scaleX, height - 1200 * scaleY);
    // offsetLeft/Top use the containing block selected before mounting the layer.
    layer.style.left = `${img.offsetLeft + img.clientLeft + (parseFloat(computed.paddingLeft) || 0)}px`;
    layer.style.top = `${img.offsetTop + img.clientTop + (parseFloat(computed.paddingTop) || 0)}px`;
    layer.style.width = `${width}px`;
    layer.style.height = `${height}px`;
    layer.style.borderRadius = computed.borderRadius;
    plane.style.left = `${left}px`;
    plane.style.top = `${top}px`;
    plane.style.transform = `scale(${scaleX},${scaleY})`;
    sync(record);
  }

  const resize = new ResizeObserver(entries => entries.forEach(entry => {
    const record = records.get(entry.target);
    if (record) layout(record);
  }));
  const visibility = new IntersectionObserver(entries => entries.forEach(entry => {
    const record = records.get(entry.target);
    if (!record) return;
    record.visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
    loadBadge(record);
    sync(record);
  }), { threshold: [0, 0.2] });

  function remove(img) {
    const record = records.get(img);
    if (!record) return;
    records.delete(img);
    resize.unobserve(img);
    visibility.unobserve(img);
    img.removeEventListener('load', record.onLoad);
    img.removeEventListener('error', record.onError);
    releaseSuppressed(record);
    record.layer.remove();
    const container = containers.get(record.parent);
    if (container && --container.count === 0) {
      if (container.changed && record.parent.style.position === 'relative') {
        record.parent.style.position = container.previous;
      }
      containers.delete(record.parent);
    }
  }

  function update(img) {
    const photograph = displayedPhotograph(img);
    let record = records.get(img);
    if (!photograph || !img.isConnected) { remove(img); return; }
    if (record && (record.photograph !== photograph || record.imageParent !== img.parentElement || !record.parent.contains(img))) { remove(img); record = null; }
    if (!record) {
      let parent = img.parentElement;
      if (parent?.tagName === 'PICTURE') parent = parent.parentElement;
      if (!parent) return;
      if (getComputedStyle(img).position === 'absolute' && img.offsetParent?.contains(img)) parent = img.offsetParent;
      let container = containers.get(parent);
      if (!container) {
        const changed = getComputedStyle(parent).position === 'static';
        container = { count: 0, changed, previous: parent.style.position };
        containers.set(parent, container);
        if (changed) parent.style.position = 'relative';
      }
      container.count++;
      const layer = document.createElement('span');
      layer.className = 'rnf-original-photo-badge';
      layer.setAttribute('aria-hidden', 'true');
      layer.hidden = true;
      const plane = document.createElement('span');
      plane.className = 'rnf-original-photo-badge__plane';
      const plate = document.createElement('span');
      plate.className = 'rnf-original-photo-badge__plate';
      const wheel = document.createElement('span');
      wheel.className = 'rnf-original-photo-badge__wheel';
      const face = document.createElement('span');
      face.className = 'rnf-original-photo-badge__face';
      const [x, y, size, duration] = photograph.wheel;
      wheel.style.cssText = `left:${x}px;top:${y}px;width:${size}px;height:${size}px;--rnf-original-turn:${duration}s`;
      if (photograph.wheelDisplay) {
        const [displayX, displayY, displaySize] = photograph.wheelDisplay;
        wheel.style.transformOrigin = '0 0';
        wheel.style.transform = `translate(${displayX - x}px,${displayY - y}px) scale(${displaySize / size})`;
      }
      face.style.backgroundPosition = `${-x}px ${-y}px`;
      wheel.append(face);
      plane.append(plate, wheel);
      layer.append(plane);
      parent.append(layer);
      record = { img, parent, imageParent: img.parentElement, photograph, layer, plane, plate, face, ready: false, visible: false, hasSize: false, suppressed: new Set() };
      record.onLoad = () => update(img);
      record.onError = () => { record.ready = false; sync(record); };
      records.set(img, record);
      img.addEventListener('load', record.onLoad);
      img.addEventListener('error', record.onError);
      resize.observe(img);
      visibility.observe(img);
    }
    layout(record);
  }

  function flush() {
    frame = 0;
    records.forEach((record, img) => { if (!img.isConnected) remove(img); });
    const images = Array.from(queued);
    queued.clear();
    images.forEach(update);
  }
  function queue(img) {
    queued.add(img);
    if (!frame) frame = requestAnimationFrame(flush);
  }
  function mount(scope) {
    if (scope.matches?.('img')) queue(scope);
    scope.querySelectorAll?.('img').forEach(queue);
  }
  const mutations = new MutationObserver(changes => {
    changes.forEach(change => {
      if (change.type === 'attributes') {
        if (change.target.tagName === 'IMG') queue(change.target);
        else if (change.target.tagName === 'SOURCE') mount(change.target.parentElement);
        else if (change.attributeName === 'style' || change.attributeName === 'class') {
          records.forEach(record => { if (change.target.contains(record.img)) queue(record.img); });
        }
      } else {
        change.addedNodes.forEach(node => { if (node.nodeType === 1) mount(node); });
        if (change.removedNodes.length && !frame) frame = requestAnimationFrame(flush);
        records.forEach(record => {
          if (change.target === record.img.parentElement && Array.from(change.addedNodes).some(node => node.matches?.('.rnf-card-rim,.rnf-wheel-layer,.rnf-spin-wheel-badge'))) queue(record.img);
        });
      }
    });
  });
  mutations.observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['src', 'srcset', 'sizes', 'data-src', 'data-srcset', 'data-lazy-src', 'data-lazy-srcset', 'class', 'style']
  });
  const syncAll = () => records.forEach(sync);
  // Capture also catches completion after a variant temporarily removed its old record.
  const imageLoaded = event => { if (event.target.tagName === 'IMG') queue(event.target); };
  const sectionLoad = event => mount(event.target);
  const sectionUnload = event => records.forEach((record, img) => { if (event.target.contains(img)) remove(img); });
  const preview = event => {
    const record = records.get(event.detail?.base);
    if (record) { record.previewing = event.type === 'rnf:preview:start'; sync(record); }
  };
  document.addEventListener('visibilitychange', syncAll);
  document.addEventListener('load', imageLoaded, true);
  reduced.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', sectionLoad);
  document.addEventListener('shopify:section:unload', sectionUnload);
  document.addEventListener('rnf:preview:start', preview);
  document.addEventListener('rnf:preview:end', preview);
  window.__rnfOriginalPhotoBadge = {
    mount,
    destroy() {
      destroyed = true;
      mutations.disconnect(); resize.disconnect(); visibility.disconnect();
      if (frame) cancelAnimationFrame(frame);
      records.forEach((record, img) => remove(img));
      document.removeEventListener('visibilitychange', syncAll);
      document.removeEventListener('load', imageLoaded, true);
      reduced.removeEventListener('change', syncAll);
      document.removeEventListener('shopify:section:load', sectionLoad);
      document.removeEventListener('shopify:section:unload', sectionUnload);
      document.removeEventListener('rnf:preview:start', preview);
      document.removeEventListener('rnf:preview:end', preview);
      style.remove();
      delete window.__rnfOriginalPhotoBadge;
    }
  };
  mount(document);
})();
